import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { Customer } from "../../models/customer.model";
import { Dept, DeptDetail } from "../../models/dept.model";
import Shop from "../../models/shop.model";

@Component({
  selector: "ngx-dialog-print-dept-details",
  templateUrl: "dialog-print-dept-details.component.html",
  styleUrls: ["dialog-print-dept-details.component.scss"],
})
export class DialogPrintDeptDetailsComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() user?: User;
  @Input() shop?: Shop;
  @Input() object?: any;
  @Input() mode?: string; //customer / supplier
  @Input() type?: string = "print"; //print / export
  @Input() fromDate?: Date = new Date();
  @Input() toDate?: Date = new Date();
  @Input() deptDetail?: DeptDetail[] = [];
  @Input() paymentDebits?: Dept[] = [];
  @Input() initAmount?: number;
  @Input() lastAmount?: number;
  @Input() saleAmount?: number;
  @Input() paidAmount?: number;
  @Input() debitAmount?: number;
  @Input() discountAmount?: number;

  @ViewChild("printBtn") printBtn: ElementRef<HTMLElement>;

  loading = false;
  printing = false;
  displayName = "";
  menu = "pos"; //a4 , pos
  isRefLanguage = false;

  constructor(
    protected ref: NbDialogRef<DialogPrintDeptDetailsComponent>,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;
          this.shopId = user.shopId ? user.shopId : user.uid;
          this.displayName = user.displayName ? user.displayName : user.email;
        } else {
          this.uid = "anonymous";
          this.shopId = "anonymous";
          this.displayName = "";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    if (this.type === "print") {
      setTimeout(() => {
        this.print();
      }, 1000);
    }
  }

  selectMenu(value) {
    this.menu = value;
  }

  cancel() {
    this.ref.close();
  }

  print() {
    this.printing = true;
    let el: HTMLElement = this.printBtn.nativeElement;
    el.click();
    this.ref.close(true);
  }

  exportAsXLSX() {
    this.ref.close(true);
  }
}
